module.exports = __webpack_public_path__ + "static/media/laa.4ff7b910.ogg";